<div class="pin-entry-container">
  <!-- Logo -->
  <div class="logo-area">
    <app-logo size="md"></app-logo>
  </div>

  <!-- Title -->
  <h2 class="pin-title">{{ 'pin.unlockTitle' | translate }}</h2>
  <p class="pin-subtitle">{{ 'pin.unlockSubtitle' | translate }}</p>

  <!-- PIN Dots -->
  <div
    class="pin-dots"
    [class.error]="error()"
    [class.success]="showSuccess()"
    role="status"
    aria-live="polite"
    [attr.aria-label]="'pin.digitsEntered' | translate: { count: pin().length }"
  >
    @for (i of [0, 1, 2, 3]; track i) {
      <div class="dot" [class.filled]="pin().length > i"></div>
    }
  </div>

  <!-- Error Message -->
  @if (error() && !lockoutInfo()?.isLocked) {
    <p class="error-text" aria-live="assertive">{{ error() | translate }}</p>
  }

  <!-- Lockout Display -->
  @if (lockoutInfo()?.isLocked) {
    <div class="lockout-display" aria-live="polite">
      <p class="lockout-label">{{ 'pin.lockedOut' | translate }}</p>
      <p class="lockout-timer">{{ lockoutTimer() }}</p>
    </div>
  }

  <!-- Processing -->
  @if (isProcessing() && !showSuccess()) {
    <p class="processing-text">{{ 'pin.verifying' | translate }}</p>
  }

  <!-- Spacer -->
  <div class="spacer"></div>

  <!-- Biometric Button -->
  @if (biometricAvailable() && !lockoutInfo()?.isLocked) {
    <div class="biometric-area">
      <ion-button
        fill="clear"
        (click)="onBiometric()"
        [disabled]="isProcessing()"
        [attr.aria-label]="'pin.unlockWithBiometric' | translate: { type: biometricType() }"
      >
        <ion-icon slot="icon-only" name="finger-print-outline"></ion-icon>
      </ion-button>
    </div>
  }

  <!-- Keypad -->
  <app-pin-keypad
    [disabled]="isProcessing() || !!lockoutInfo()?.isLocked"
    (digitPressed)="onDigit($event)"
    (deletePressed)="onDelete()"
  ></app-pin-keypad>

  <!-- Forgot PIN -->
  <button class="forgot-pin-btn" type="button" (click)="onForgotPin()">
    {{ 'pin.forgotPin' | translate }}
  </button>
</div>
